import React from 'react'
import Header from '../Header'

const TermsAndConditions = () => {
    return (
        <div>
            <Header />
            <div className="container-md mb-5">
                <h1 className="h1 mb-4">Terms and Conditions</h1>
                <p><strong>Last Updated: December 31, 2025</strong></p>

                <h2 className="h2 mt-4 mb-3">1. Introduction</h2>
                <p>
                    Welcome to Rupee For Humanity (the "Website"). These Terms and Conditions govern your
                    access to and use of <a href="https://www.rupeeforhumanity.org/">https://www.rupeeforhumanity.org/</a>{' '}
                    and all related services, including donations, event registrations, volunteer programs,
                    and other activities offered by Rupee For Humanity.
                </p>
                <p>
                    By accessing or using the Website, you agree to be bound by these Terms and Conditions
                    and our Privacy Policy. If you do not agree with any part of these terms, please do not
                    use our Website or services.
                </p>

                <h2 className="h2 mt-4 mb-3">2. About Rupee For Humanity</h2>
                <p>
                    Rupee For Humanity is a registered charitable organization under Section 80G of the
                    Income Tax Act, 1961. We are committed to supporting underprivileged children through
                    education, healthcare, nourishment, and other charitable initiatives.
                </p>
                <ul>
                    <li><strong>Organization Name:</strong> Rupee For Humanity</li>
                    <li><strong>80G Registration Number:</strong> AABAR8880PF20231</li>
                    <li><strong>PAN Number:</strong> AABAR8880P</li>
                    <li><strong>Email:</strong> <a href="mailto:rupee4humanity@gmail.com">rupee4humanity@gmail.com</a></li>
                    <li><strong>Website:</strong> <a href="https://www.rupeeforhumanity.org/">https://www.rupeeforhumanity.org/</a></li>
                </ul>

                <h2 className="h2 mt-4 mb-3">3. Use of Website</h2>

                <h3 className="h3 mt-3">3.1 Permitted Use</h3>
                <p>You may use the Website for the following purposes:</p>
                <ul>
                    <li>Browsing information about our charitable activities and initiatives</li>
                    <li>Making donations to support our cause</li>
                    <li>Registering for events (marathons, fundraising activities, etc.)</li>
                    <li>Signing up as a volunteer</li>
                    <li>Contacting us for inquiries or support</li>
                    <li>Accessing educational content and updates about our work</li>
                </ul>

                <h3 className="h3 mt-3">3.2 Prohibited Use</h3>
                <p>You may NOT use the Website to:</p>
                <ul>
                    <li>Modify, distribute, transmit, display, perform, reproduce, publish, license, create
                        derivative works from, transfer, or sell any content obtained from the Website without
                        our express written permission</li>
                    <li>Engage in any commercial use of the Website without authorization</li>
                    <li>Use automated systems (bots, scrapers, crawlers) to access or collect data from the Website</li>
                    <li>Reverse engineer, decompile, or disassemble any software or technology used on the Website</li>
                </ul>

                <h2 className="h2 mt-4 mb-3">4. User Conduct</h2>
                <p>As a user of the Website, you agree to conduct yourself responsibly and not to:</p>
                <ul>
                    <li><strong>Engage in illegal activities:</strong> Use the Website for any unlawful, fraudulent,
                        or harmful purpose</li>
                    <li><strong>Violate intellectual property rights:</strong> Infringe upon copyrights, trademarks,
                        patents, or other proprietary rights</li>
                    <li><strong>Violate laws and regulations:</strong> Breach any applicable local, state, national,
                        or international law</li>
                    <li><strong>Harass or abuse others:</strong> Engage in threatening, abusive, defamatory, or
                        discriminatory behavior toward other users, volunteers, or staff</li>
                    <li><strong>Disrupt services:</strong> Interfere with or disrupt the normal functioning of the
                        Website or servers</li>
                    <li><strong>Gain unauthorized access:</strong> Attempt to bypass security measures, hack into
                        systems, or access restricted areas</li>
                    <li><strong>Spam or phish:</strong> Send unsolicited emails, spam messages, or engage in phishing
                        activities</li>
                    <li><strong>Spread malware:</strong> Upload viruses, malware, or any other malicious code</li>
                    <li><strong>Provide false information:</strong> Submit fraudulent, misleading, or inaccurate
                        information during registration, donation, or any other interaction</li>
                </ul>

                <h2 className="h2 mt-4 mb-3">5. Donations</h2>

                <h3 className="h3 mt-3">5.1 Donation Policy</h3>
                <p>
                    All donations made to Rupee For Humanity are voluntary contributions to support our
                    charitable mission. By making a donation, you acknowledge that:
                </p>
                <ul>
                    <li>Donations are final and non-refundable (except as outlined in our Refund Policy)</li>
                    <li>You will receive a tax receipt (80G certificate) for donations eligible under Indian tax law</li>
                    <li>Donations will be used for charitable purposes as determined by Rupee For Humanity</li>
                    <li>We reserve the right to redirect donations to the most pressing needs if a specific cause
                        becomes fully funded or no longer requires support</li>
                </ul>

                <h3 className="h3 mt-3">5.2 Payment Processing</h3>
                <p>
                    Payments are processed through third-party payment gateways (PhonePe, UPI, bank transfers).
                    By making a payment, you agree to the terms and conditions of the payment processor.
                </p>

                <h3 className="h3 mt-3">5.3 Tax Benefits</h3>
                <p>
                    Donations to Rupee For Humanity are eligible for 50% tax deduction under Section 80G of
                    the Income Tax Act, 1961. We will issue a valid 80G receipt containing all required details
                    including PAN number, donation amount, and transaction details.
                </p>

                <h2 className="h2 mt-4 mb-3">6. Event Registrations</h2>
                <p>
                    When you register for an event (marathon, fundraiser, etc.), you agree to:
                </p>
                <ul>
                    <li>Provide accurate and complete registration information</li>
                    <li>Comply with all event rules, guidelines, and code of conduct</li>
                    <li>Accept the terms outlined in our Refund Policy regarding cancellations</li>
                    <li>Assume responsibility for your own health, safety, and well-being during participation</li>
                    <li>Grant permission for photographs/videos taken during events to be used for promotional purposes</li>
                </ul>

                <h2 className="h2 mt-4 mb-3">7. Intellectual Property Rights</h2>

                <h3 className="h3 mt-3">7.1 Ownership</h3>
                <p>
                    All content on the Website, including but not limited to text, graphics, logos, images,
                    videos, audio clips, software, and design elements, is the property of Rupee For Humanity
                    or its licensors and is protected by Indian and international copyright laws.
                </p>

                <h3 className="h3 mt-3">7.2 Trademarks</h3>
                <p>
                    "Rupee For Humanity" and all related logos, service marks, and trade names are trademarks
                    of Rupee For Humanity. You may not use these trademarks without our prior written consent.
                </p>

                <h3 className="h3 mt-3">7.3 Limited License</h3>
                <p>
                    You are granted a limited, non-exclusive, non-transferable license to access and use the
                    Website for personal, non-commercial purposes. This license does not permit downloading
                    (other than page caching), modifying, or reproducing content without permission.
                </p>

                <h2 className="h2 mt-4 mb-3">8. Third-Party Links and Services</h2>
                <p>
                    The Website may contain links to third-party websites, services, or resources (payment
                    gateways, social media, partner organizations). These links are provided for your convenience.
                </p>
                <p>
                    <strong>We are not responsible for:</strong>
                </p>
                <ul>
                    <li>The content, accuracy, or reliability of third-party websites</li>
                    <li>Privacy practices or security of external sites</li>
                    <li>Any transactions or interactions you have with third parties</li>
                </ul>
                <p>
                    We recommend reviewing the terms and privacy policies of any third-party sites before use.
                </p>

                <h2 className="h2 mt-4 mb-3">9. Disclaimer of Warranties</h2>
                <p>
                    THE WEBSITE AND ALL SERVICES ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS WITHOUT
                    WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO:
                </p>
                <ul>
                    <li>Implied warranties of merchantability</li>
                    <li>Fitness for a particular purpose</li>
                    <li>Non-infringement</li>
                    <li>Accuracy, reliability, or completeness of content</li>
                    <li>Uninterrupted or error-free operation</li>
                </ul>
                <p>
                    We do not guarantee that the Website will be free from viruses, bugs, or other harmful
                    components. You use the Website at your own risk.
                </p>

                <h2 className="h2 mt-4 mb-3">10. Limitation of Liability</h2>
                <p>
                    TO THE FULLEST EXTENT PERMITTED BY LAW, RUPEE FOR HUMANITY, ITS OFFICERS, DIRECTORS,
                    EMPLOYEES, VOLUNTEERS, AND AFFILIATES SHALL NOT BE LIABLE FOR:
                </p>
                <ul>
                    <li>Any indirect, incidental, special, consequential, or punitive damages</li>
                    <li>Loss of profits, revenue, data, or business opportunities</li>
                    <li>Damages arising from use or inability to use the Website</li>
                    <li>Errors, mistakes, or inaccuracies in content</li>
                    <li>Unauthorized access to or alteration of your data</li>
                    <li>Third-party conduct or content on the Website</li>
                </ul>
                <p>
                    In no event shall our total liability exceed the amount you paid to us in the six (6)
                    months preceding the claim, or INR 1,000, whichever is less.
                </p>

                <h2 className="h2 mt-4 mb-3">11. Indemnification</h2>
                <p>
                    You agree to indemnify, defend, and hold harmless Rupee For Humanity and its officers,
                    directors, employees, volunteers, and affiliates from any claims, liabilities, damages,
                    losses, costs, or expenses (including legal fees) arising from:
                </p>
                <ul>
                    <li>Your use or misuse of the Website</li>
                    <li>Violation of these Terms and Conditions</li>
                    <li>Violation of any rights of another person or entity</li>
                    <li>Any content you submit or transmit through the Website</li>
                </ul>

                <h2 className="h2 mt-4 mb-3">12. Privacy and Data Protection</h2>
                <p>
                    Your use of the Website is also governed by our Privacy Policy, which explains how we
                    collect, use, and protect your personal information. By using the Website, you consent
                    to our data practices as described in the Privacy Policy.
                </p>
                <p>
                    Please review our <a href="/privacy-policy">Privacy Policy</a> for detailed information.
                </p>

                <h2 className="h2 mt-4 mb-3">13. Termination</h2>
                <p>
                    We reserve the right to suspend or terminate your access to the Website at any time,
                    without notice, for any reason, including but not limited to:
                </p>
                <ul>
                    <li>Violation of these Terms and Conditions</li>
                    <li>Fraudulent, abusive, or illegal activity</li>
                    <li>Threats to the security or integrity of the Website</li>
                    <li>Requests by law enforcement or government agencies</li>
                </ul>
                <p>
                    Upon termination, your right to use the Website will immediately cease. Sections relating
                    to disclaimers, liability, indemnification, and governing law shall survive termination.
                </p>

                <h2 className="h2 mt-4 mb-3">14. Modifications to Terms</h2>
                <p>
                    We reserve the right to modify these Terms and Conditions at any time. Changes will be
                    effective immediately upon posting on this page with an updated "Last Updated" date.
                </p>
                <p>
                    Your continued use of the Website after changes constitutes acceptance of the modified terms.
                    We encourage you to review these Terms periodically.
                </p>

                <h2 className="h2 mt-4 mb-3">15. Governing Law and Jurisdiction</h2>
                <p>
                    These Terms and Conditions shall be governed by and construed in accordance with the laws
                    of India, without regard to conflict of law principles.
                </p>
                <p>
                    Any disputes, claims, or controversies arising out of or relating to these Terms or your
                    use of the Website shall be subject to the exclusive jurisdiction of the courts located
                    in Bangalore, Karnataka, India.
                </p>

                <h2 className="h2 mt-4 mb-3">16. Dispute Resolution</h2>
                <p>
                    In the event of any dispute, we encourage you to first contact us at{' '}
                    <a href="mailto:rupee4humanity@gmail.com">rupee4humanity@gmail.com</a> to attempt to resolve
                    the matter informally. We are committed to working with you in good faith to find a mutually
                    acceptable resolution.
                </p>

                <h2 className="h2 mt-4 mb-3">17. Severability</h2>
                <p>
                    If any provision of these Terms and Conditions is found to be invalid, illegal, or
                    unenforceable, the remaining provisions shall continue in full force and effect.
                </p>

                <h2 className="h2 mt-4 mb-3">18. Waiver</h2>
                <p>
                    Our failure to enforce any right or provision of these Terms shall not constitute a waiver
                    of such right or provision. Any waiver must be in writing and signed by an authorized
                    representative of Rupee For Humanity.
                </p>

                <h2 className="h2 mt-4 mb-3">19. Entire Agreement</h2>
                <p>
                    These Terms and Conditions, together with our Privacy Policy and Refund Policy, constitute
                    the entire agreement between you and Rupee For Humanity regarding your use of the Website
                    and supersede all prior agreements and understandings.
                </p>

                <h2 className="h2 mt-4 mb-3">20. Contact Information</h2>
                <p>
                    If you have any questions, concerns, or feedback regarding these Terms and Conditions,
                    please contact us:
                </p>
                <ul>
                    <li><strong>Email:</strong> <a href="mailto:rupee4humanity@gmail.com">rupee4humanity@gmail.com</a></li>
                    <li><strong>Website:</strong> <a href="https://www.rupeeforhumanity.org/">https://www.rupeeforhumanity.org/</a></li>
                    <li><strong>Organization:</strong> Rupee For Humanity</li>
                </ul>
                <p>We will respond to your inquiry within 7 business days.</p>

                <hr className="my-4" />

                <p className="text-muted small">
                    <strong>Note:</strong> By using our Website and services, you acknowledge that you have read,
                    understood, and agree to be bound by these Terms and Conditions.
                </p>
            </div>
        </div>
    )
}

export default TermsAndConditions